export const SourceHireLayoutRoutes = {
    "?source-hire": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.harriSH",
        "type": "frontend",
        "abstract": true,
        "component": "sourceHireLayoutContainer",
        "route_styles": {
            framework: "bootstrap_v4",
        },
    },
};